module.exports = "../../../../platform/assets/pageMainIcon/icon-tongyong-2-red.svg";